module.exports = __webpack_public_path__ + "static/media/emptyImageRollout.1e761cd8.png";